import { cn } from '@/lib/utils';

interface BatteryBarProps {
  pct?: number | null;
  className?: string;
}

export function BatteryBar({ pct, className }: BatteryBarProps) {
  const v = pct == null ? null : Math.max(0, Math.min(100, pct));
  const color =
    v == null ? 'bg-fg-disabled' :
    v < 15 ? 'bg-status-critical' :
    v < 25 ? 'bg-status-warn' :
    'bg-status-good';

  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      <div className="relative flex h-2.5 w-12 items-center rounded-sm border border-border-default bg-surface-1">
        <span
          className={cn('h-full rounded-sm', color)}
          style={{ width: `${v ?? 0}%` }}
        />
      </div>
      <span className="font-mono text-[10px] text-fg-secondary tabular-nums">
        {v == null ? '—' : `${v.toFixed(0)}%`}
      </span>
    </div>
  );
}
